export default "__VITE_ASSET__d972f320__"